import { SEO } from "@/components/SEO";
import { Marquee } from "@/components/Marquee";
import { CTASection } from "@/components/CTASection";
import { Hero } from "@/sections/Hero";
import { ValueProp } from "@/sections/ValueProp";
import { EyesEarsHands } from "@/sections/EyesEarsHands";
import { ServicesBento } from "@/sections/ServicesBento";
import { Lifecycle } from "@/sections/Lifecycle";
import { Maintenance } from "@/sections/Maintenance";
import { RentReporting } from "@/sections/RentReporting";
import { DashboardPreview } from "@/sections/DashboardPreview";
import { HowItWorksSection } from "@/sections/HowItWorksSection";
import { Comparison } from "@/sections/Comparison";
import { PricingTeaser } from "@/sections/PricingTeaser";
import { HomeFAQ } from "@/sections/HomeFAQ";

export default function Home() {
  return (
    <>
      <SEO
        title="NRI Property Services Hyderabad | Property Management for NRIs"
        description="Professional NRI property management in Hyderabad. Tenant management, rent collection, inspections, maintenance, cleaning, repairs and end-to-end property care."
        path="/"
      />
      <Hero />
      <Marquee />
      <ValueProp />
      <EyesEarsHands />
      <ServicesBento />
      <Lifecycle />
      <Maintenance />
      <RentReporting />
      <DashboardPreview />
      <HowItWorksSection />
      <Comparison />
      <PricingTeaser />
      <HomeFAQ />
      <CTASection />
    </>
  );
}
